import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS and Taining S41 machines

export default function FeederTensionSettingRow() {
   return (
      <InputRangeRow
         titleProp={"Feeder Tension Setting"}
         descriptionProp={"g"}
         sizeProp={4}
         typeProp={"text"}
         minProp={2}
         maxProp={995}
         propertyNameProp={"feederTensionSet"}
         errorDialogueProp={"2-995 only"}
         floatProp={false}
      />
   );
}
